import React from "react";
import styled from "styled-components";
import logo from "./Images/Header.png";
import "./App.css";

const HomeContainer = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 0 1rem;
  background-color: #f5e9dd;
`;

const HomeWrapper = styled.div`
  background-color: rgb(255, 246, 237);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 1px solid #1c4587;
  border-image: url("data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3cfilter id='noiseFilter'%3e%3cfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='4' stitchTiles='stitch'/%3e%3c/filter%3e%3crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3e%3c/svg%3e")
    1;
  border-style: solid;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
`;

const TitleImage = styled.img`
  max-width: 150px;
  height: auto;
  margin-bottom: 1rem;
  flex-shrink: 0;
`;

const InvitationText = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 3vmin;
  margin: 0;
`;

const Names = styled.p`
  font-family: "Monsieur La Doulaise", cursive;
  font-weight: 400;
  font-style: normal;
  font-size: 8vmin;
  margin: 0;
`;

const AndText = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 3vmin;
  margin: 0;
`;

const Divider = styled.hr`
  width: 60%;
  border: none;
  border-top: 1px solid rgba(139, 121, 94, 0.4);
  margin: 1rem 0;
`;

const SubHeading = styled.div`
  font-family: "IM Fell English", serif;
  font-size: 3vmin;
  line-height: 1.6;
`;

export default function Home() {
  return (
    <HomeContainer>
      <HomeWrapper>
        <TitleImage src={logo} alt="heading-logo" />
        <InvitationText>
          You are invited to join us in celebrating the marriage of
        </InvitationText>
        <Names>Christopher Head</Names>
        <AndText>and</AndText>
        <Names>Claudia Cross</Names>
        <Divider />
        <SubHeading>
          burgundy, france
          <br />
          28 june - 5 july, 2027
        </SubHeading>
        <Divider />
      </HomeWrapper>
    </HomeContainer>
  );
}
